const userKeys = ['user'] as const;
const laboratoryKeys = ['laboratory'] as const;
const invoiceKeys = ['invoice'] as const;
const receiptKeys = ['receipt'] as const;
const fileKeys = ['file'] as const;
const boletoKeys = ['boleto'] as const;

export const queryKeys = {
  user: {
    all: userKeys,
    lists: () => [...userKeys, 'list'] as const,
    listByLaboratory: (labId: string) =>
      [...userKeys, 'list', 'by-laboratory', labId] as const,
    details: () => [...userKeys, 'detail'] as const,
    detail: (id: string) => [...userKeys, 'detail', id] as const,
  },
  laboratory: {
    all: laboratoryKeys,
    details: () => [...laboratoryKeys, 'detail'] as const,
    detail: (id: string) => [...laboratoryKeys, 'detail', id] as const,
  },
  invoice: {
    all: invoiceKeys,
    lists: () => [...invoiceKeys, 'list'] as const,
    byCnpj: (cnpj: string) =>
      [...invoiceKeys, 'list', 'by-cnpj', cnpj] as const,
  },
  receipt: {
    all: receiptKeys,
    summary: (labCode: string) =>
      [...receiptKeys, 'summary', labCode] as const,
    byDate: (labCode: string, year: string, month: string) =>
      [...receiptKeys, 'summary', labCode, year, month] as const,
  },
  file: {
    all: fileKeys,
    byCategory: (category: string) =>
      [...fileKeys, 'by-category', category] as const,
  },
  boleto: {
    all: boletoKeys,
    list: (competence?: string) =>
      [...boletoKeys, 'list', competence ?? ''] as const,
  },
} as const;
